import { SocialType } from "shared/SocialsShare/SocialsShare";
import { FC, useState } from "react";
import { 
    Dialog, 
    DialogContent, 
    DialogTitle,
    Box,
    TextField,
    Tooltip,
    IconButton,
    Snackbar
} from '@mui/material';
import { ClipboardDocumentIcon, XMarkIcon } from "@heroicons/react/24/outline";

export interface ModalShareProps {
    shareUrl?: string;
    show?: boolean;
    handleClose?: Function;
}

const socialsDemo: SocialType[] = [
    { name: "Facebook", icon: "lab la-facebook-square", href: "#" },
    { name: "Twitter", icon: "lab la-twitter", href: "#" },
    { name: "Youtube", icon: "lab la-youtube", href: "#" },
    { name: "Instagram", icon: "lab la-instagram", href: "#" },
];


const ModalShare: FC<ModalShareProps> = ({
    shareUrl="",
    show = false,
    handleClose,
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
    };
    
    return (
        <Dialog
            open={show}
            onClose={() => handleClose()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="xs"
        >
            <div className="bg-neutral-100 dark:bg-neutral-900 text-black dark:text-white">
                <DialogTitle id="alert-dialog-title">
                    Share
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                    onClick={() => handleClose()}
                >
                    <XMarkIcon className="w-5 h-5 text-black dark:text-white"/>
                </IconButton>
                <DialogContent sx={{ paddingTop:"5px" }}>
                    <Box display="flex" alignItems="center" >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={shareUrl}
                            slotProps={{
                                input: {
                                    className:
                                        'focus:outline-none focus:ring-0 ring-0 focus:ring-transparent',
                                    style: {
                                        '--tw-ring-color': 'transparent',
                                        boxShadow: 'none',
                                    } as any,
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#000', // default: black (light mode)
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#000',
                                    },
                                    '.dark & .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#fff', // override to white in dark mode
                                    },
                                    '.dark &.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#fff',
                                    },
                                },
                            }}
                            
                        />
                        <Tooltip title="Copy link">
                        <IconButton onClick={handleCopy}>
                            <ClipboardDocumentIcon className="w-5 h-5 text-black dark:text-white" />
                        </IconButton>
                        </Tooltip>
                    </Box>
                    <Snackbar
                        open={copied}
                        autoHideDuration={2000}
                        onClose={() => setCopied(false)}
                        message="Link copied to clipboard"
                    />
                    <nav
                        className={`nc-SocialsList flex space-x-2.5 text-3xl text-neutral-6000 dark:text-neutral-300 mt-4`}
                        data-nc-id="SocialsList"
                    >
                        {socialsDemo.map((item, i) => (
                            <a
                                key={i}
                                className={"block"}
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={item.name}
                            >
                                <i className={item.icon}></i>
                            </a>
                        ))}
                    </nav>
                </DialogContent>
            </div>
        </Dialog>
    );
};

export default ModalShare;
